/* ROAS blended: receita atribuída ÷ gasto total de mídia. */

export function blendedRoas(receitaAtribuida: number, gastoTotal: number): number | null {
  if (gastoTotal === 0) return null;
  return receitaAtribuida / gastoTotal;
}

/* Margem de contribuição (R$) = receita − custos variáveis não-mídia (CMV,
 * frete, imposto). É o que cada real de venda deixa para pagar a mídia, os custos
 * fixos e virar lucro — e a base do ROAS de equilíbrio. Pode ser negativa
 * (custos variáveis acima da receita) — não é dinheiro travado por invariante. */
export function contributionMargin(receita: number, custosVariaveis: number): number {
  return receita - custosVariaveis;
}

/* Margem de contribuição como fração da receita (0,444 = 44,4%). Receita ≤ 0 →
 * null (indefinida; nunca 0 forçado num número de dinheiro). */
export function contributionMarginPct(receita: number, custosVariaveis: number): number | null {
  if (receita <= 0) return null;
  return contributionMargin(receita, custosVariaveis) / receita;
}

/* ROAS de equilíbrio (breakeven): a partir de qual ROAS a mídia para de dar
 * prejuízo. = receita ÷ margem de contribuição antes da mídia. Sem margem de
 * contribuição positiva o breakeven é indefinido → null (nunca 0/Infinity). */
export function breakevenRoas(receita: number, custosVariaveis: number): number | null {
  const contribuicao = contributionMargin(receita, custosVariaveis);
  if (receita <= 0 || contribuicao <= 0) return null;
  return receita / contribuicao;
}
